(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.agendasettings');
    module.factory('Agenda', ['WebAppViewTypeEnum', 'AppointmentShowEnum', 'OnlineLoginType', 'Weekday', 'RecurrenceConflictOption', 'ContactInfoService', 'OnlineMailConfirmationOption', AgendaFn]);

    /* main agenda model */
    function AgendaFn(WebAppViewTypeEnum, AppointmentShowEnum, OnlineLoginType, Weekday, RecurrenceConflictOption, ContactInfoService, OnlineMailConfirmationOption) {

        var Agenda = function () {

            this.interval = null;
            this.fK_CancelBufferLabel = null;
            this.cancelBufferLabel = null;
            this.webAppViewType = null;
            this.appointmentShow = null;
            this.loginView = null;
            this.mailConfirmationForOnlineBooking = OnlineMailConfirmationOption.Never.value;
            this.weekStartDay = null;
            this.recurrenceConflictOption = null;
            this.translations = [];

            // vm 
            this.vmAppointmentShow = null;
            this.withCredentials = false;
            this.WithInformation = false;
            this.WithNationalNumber = false;
            this.vmMailConfirmationForOnlineBooking = OnlineMailConfirmationOption.Never;
            this.vmWebAppViewType = null;
            this.vmWeekStartDay = null;
            this.vmRecurrenceConflictOption = null;
            this.vmCiMail = ContactInfoService.createContactInfoByTypeValue(3); // contact-info for email

        };

        // do some cleaning and backend prepare 
        Agenda.prototype.prepareForSave = function () {
            var self = this;

            self.fK_CancelBufferLabel = self.cancelBufferLabel ? self.cancelBufferLabel.id : null;
            self.appointmentShow = self.vmAppointmentShow ? self.vmAppointmentShow.value : null;
            self.loginView = (
                (self.withCredentials ? OnlineLoginType.WithCredentials.value : 0) |
                (self.withInformation ? OnlineLoginType.WithInformation.value : 0) |
                (self.withNationalNumber ? OnlineLoginType.WithNationalNumber.value : 0));
            self.mailConfirmationForOnlineBooking = self.vmMailConfirmationForOnlineBooking ? self.vmMailConfirmationForOnlineBooking.value : OnlineMailConfirmationOption.Never.value;
            self.webAppViewType = self.vmWebAppViewType ? self.vmWebAppViewType.value : null;
            self.weekStartDay = self.vmWeekStartDay ? self.vmWeekStartDay.value : null;
            self.recurrenceConflictOption = self.vmRecurrenceConflictOption ? self.vmRecurrenceConflictOption.value : null;
            //reply email
            self.replyEmailForConfirmation = self.vmCiMail ? self.vmCiMail.value : null;

            // prepare for save
            delete self.cancelBufferLabel;
            delete self.vmAppointmentShow;
            delete self.vmWebAppViewType;
            delete self.withCredentials;
            delete self.withInformation;
            delete self.withNationalNumber;
            delete self.vmMailConfirmationForOnlineBooking;
            delete self.vmWeekStartDay;
            delete self.vmRecurrenceConflictOption;

            // prepare translation list
            var i = 0;
            var len = self.translations.length;
            for (i = 0; i < len; i++) {
                if (self.translations[i].language) {
                    self.fK_Language = self.translations[i].language.id;
                }
                // set required foreign keys
                self.translations[i].fK_Agenda = self.id;
                // self.translations[i].prepareForSave();
            } // for 

            // prepare select contact-info-types in appointment
            var contactTypes = [];
            i = 0;
            len = self.contactInfoTypes.length;
            for (i = 0; i < len; i++) {
                var ci = {
                    id: 0,
                    deleted: false,
                    fK_Agenda: self.id,
                    fK_UserContactInfoType: self.contactInfoTypes[i].id
                };
                contactTypes.push(ci);
            } // for
            self.contactInfoTypesInAppointment = contactTypes;

            // delete self.contactInfoTypes;
            // delete self.vmCiMail;

        }; // prepareForSave

        // extend
        Agenda.prototype.extend = function (object) {
            var self = this;
            angular.extend(self, object);
            
            // dont show deleted translations
            self.translations = self.translations.filter(t => !t.deleted);

            // set values for view
            self.vmCiMail.value = self.replyEmailForConfirmation;

            // appointment show
            angular.forEach(AppointmentShowEnum, function (item) {
                if (item.value === self.appointmentShow) {
                    self.vmAppointmentShow = item;
                } // if
            });

            // web app view type
            angular.forEach(WebAppViewTypeEnum, function (item) {
                if (item.value === self.webAppViewType) {
                    self.vmWebAppViewType = item;
                } // if
            });

            // login view
            self.withCredentials = self.loginView == null || self.loginView === 0 || ((self.loginView & OnlineLoginType.WithCredentials.value) > 0);
            self.withInformation = self.loginView == null || self.loginView === 0 || ((self.loginView & OnlineLoginType.WithInformation.value) > 0);
            self.withNationalNumber = self.loginView != null && ((self.loginView & OnlineLoginType.WithNationalNumber.value) > 0);

            // MailConfirmationForOnlineBooking
            angular.forEach(OnlineMailConfirmationOption, function (item) {
                if (item.value === self.mailConfirmationForOnlineBooking) {
                    self.vmMailConfirmationForOnlineBooking = item;
                }
            });

            // weekstartday
            angular.forEach(Weekday, function (item) {
                if (item.value === self.weekStartDay) {
                    self.vmWeekStartDay = item;
                } // if
            });

            // recurrence conflict options
            angular.forEach(RecurrenceConflictOption, function (item) {
                if (item.value === self.recurrenceConflictOption) {
                    self.vmRecurrenceConflictOption = item;
                } // if
            });

        };

        return Agenda;
    }
})();